module.exports = __webpack_public_path__ + "static/media/Scroll-Down.845d53c5.gif";